import React, { useContext } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { DashboardIcon, TodoListIcon, GuestListIcon, BudgetCalculatorIcon, SeatingPlannerIcon, GiftRegistryIcon, CompetitionIcon, UnveiledIcon } from "@assets/icons"
import { getCountry } from '@helper/getConfigValues'
import scss from './PlanningTools.module.scss'
import LoginContext from "@contexts/loginContext"

interface ItemProps {
  icon: React.ReactNode
  title: string
  url: string
  className?: string
  children: React.ReactNode
}

function Item({ icon, title, url, className = '', children }: ItemProps) {
  return (<div className={`${scss.item} ${className}`}>
    <div className={scss.itemIcon}>
      {icon}
    </div>
    <div className={scss.itemTitle}>
      <a className={scss.itemLink} href={url}>{title}</a>
      <FontAwesomeIcon icon={faChevronRight} size="xs" className={scss.chevronIcon} />
    </div>
    <div className={scss.itemDescription}>{children}</div>
  </div>)
}

function PlanningToolsDropdownMenu() {
  const { isLoggedIn } = useContext(LoginContext);
  const countryCode = getCountry();
  
  return <div className={scss.container}>
    <Item
      title="My wedding"
      url={isLoggedIn ? "/dashboard/" : "/planning-tools/"}
      icon={<DashboardIcon className={scss.icon} />}
      className={scss.bigItem}>
      Track your progress and access all of your wedding planning tools in one place.
    </Item>
    <Item
      title="To Do List"
      url={isLoggedIn ? "/tools/todolist/" : "/planning-tools/to-do-list/"}
      icon={<TodoListIcon className={scss.icon} />}>
      A step - by - step checklist of things to be done before your big day.
    </Item >
    <Item
      title="Guest List"
      url={isLoggedIn ? "/tools/guestlist/" : "/planning-tools/guest-list/"}
      icon={<GuestListIcon className={scss.icon} />}>
      See which guests are coming and which aren't at a glance.
    </Item>
    <Item
      title="Budget Calculator"
      url={isLoggedIn ? "/tools/budgetcalculator/" : "/planning-tools/budget-calculator/"}
      icon={<BudgetCalculatorIcon className={scss.icon} />}>
      Keep track of all spending associated with your big day.
    </Item>
    <Item
      title="Seating Planner"
      url={isLoggedIn ? "/tools/seatingplanner/" : "/planning-tools/seating-planner/"}
      icon={<SeatingPlannerIcon className={scss.icon} />}>
      Organise your guest seating arrangements for all your events.
    </Item>
    {countryCode == "au" && <Item
      title="Gift Registry"
      url="/registry/"
      icon={<GiftRegistryIcon className={scss.icon} />}>
      Share your registry so guests can start contributing funds to your wishing well!
    </Item>}
    {countryCode === 'au' && <Item
      title="Competition"
      url="/competition/"
      icon={<CompetitionIcon className={scss.icon} />}>
      Enquire with and book your suppliers to go into the draw.
    </Item>}
    {countryCode === 'au' && <Item
      title="Unveiled Event"
      url="/unveiled/?utm_source=nav&utm_medium=planning_menu&utm_campaign=unveiled_cta"
      icon={<UnveiledIcon className={scss.icon} />}>
      Connect with real couples, trusted vendors, and planning experts at your ultimate wedding planning day out!
    </Item>}
  </div>
}

export default PlanningToolsDropdownMenu
